import ErrorBox from "components/blocks/error/ErrorBox";

export default function ErrorPage(): JSX.Element {
  const onReturn = () => {
    window.location.reload();
  };
  return (
    <ErrorBox
      title="Error"
      subtitle="Sorry, an error occurred."
      onReturn={onReturn}
    >
      <h3>An error occurred while processing your request.</h3>
      <p>Please try again later or contact support if the problem persists.</p>
    </ErrorBox>
  );
}
